import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import * as c from 'models/constants';
import { translate } from 'react-i18next';

interface IProps {
	section: IMagazinePageSection;
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType13 extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { elements } = this.props.section.data;

		return (
			<div className="container-fluid sectionType13container">
				<div className="row">
					<div className="col-lg-12 col-md-12 no_pad">
						<div
							className={`magazineHeroBanner ${
								(elements[0] as ISectionImageElement).imageUrl !== null ? 'background-set' : ''
							}`}
							style={{ backgroundImage: `url(${(elements[0] as ISectionImageElement).imageUrl})` }}
						>
							<div
								className={`magazineHeroBanner-wrapper ${
									(elements[1] as ISectionTextElement).text !== null || (elements[1] as ISectionTextElement).text
										? 'text-set'
										: ''
								}`}
							>
								<div className="magazineHeroBanner-wrapper-inner">
									<div className="container">
										<div className="row align-items-center justify-content-center">
											<div className="col-lg-8">
												<h1 className="text title" title={(elements[1] as ISectionTextElement).text}>
													{(elements[1] as ISectionTextElement).text}
												</h1>
												<p className="p12 text description">{(elements[3] as ISectionTextElement).text}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType13 };
